let promise;
export const loadGuidePage=()=>promise ||= import('../pages/seo/TjanaPengarKlassresanPage.jsx');
